<div btn (click)="toggle()" id="dropdownDefault"
  class="dropdown text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
  type="button">
  {{ _selected.length >0 ?  _selected : 'Select missions' }}
  <nb-icon class="absolute right-4" *ngIf="!Show" icon="arrow-ios-downward-outline"></nb-icon>
  <nb-icon class="absolute right-4" *ngIf="Show" icon="arrow-ios-upward-outline"></nb-icon>
</div>
<!-- Dropdown menu -->
<div *ngIf="Show" class="dropdown_menu z-10 bg-white absolute py-1 border border-1 border-neutral-400 rounded-md cursor-pointer">
  <div class="py-2 px-4 w-full hover:bg-neutral-100" *ngFor="let element of elements; let i = index">
    <nb-checkbox *ngIf="multiple" [checked]="checkedElements[i]" (checkedChange)="toggleCheck($event,i)">{{ element.name | txtTranslate }}</nb-checkbox> 
  </div>
</div>